import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { DateRangeModule } from 'Angular/features/components/date-controls/date-range/date-range.module';
import { FullYearDateRangeModule } from 'Angular/features/components/date-controls/full-year-date-range/full-year-date-range.module';
import { SingleSelectDropdownModule } from 'Angular/features/components/dropdowns/single-select-dropdown/single-select-dropdown.module';
import { SkeletonLoadersListModule } from 'Angular/features/components/loaders/skeleton-loaders-list/skeleton-loaders.module';
import { HelpModalModule } from 'Angular/features/components/modals/help-modal/help-modal.module';
import { DisabledModule } from 'Angular/features/directives/disabled/disabled.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';
import { MetricSelectorModalModule } from 'CalculationsApp/ts/features/metric-selector-modal/metric-selector-modal.module';
import { ChartsSharedModule } from 'ChartApp/ts/features/charts-shared/charts-shared.module';
import { TechChartModule } from 'ChartApp/ts/features/tech-chart/tech-chart.module';
import { LegacyAssetConversionCheckerModule } from 'ConverterApp/features/legacy-asset-conversion-checker/legacy-asset-conversion-checker.module';
import { FoldersSharedModule } from 'FoldersApp/features/folders-shared/app.module';
import { AddButtonAutocompleteModule } from 'SearchApp/ts/features/add-button-autocomplete/add-button-autocomplete.module';
import { SecurityListSelectorModalModule } from 'SecurityListsApp/ts/features/security-list-selector-modals/security-list-selector-modal.module';
import { GetOwnerDisplayNamePipeModule } from 'SharingApp/ts/pipes/get-owner-display-name.module';
import * as i0 from "@angular/core";
export class TechChartPageSharedModule {
}
TechChartPageSharedModule.ɵfac = function TechChartPageSharedModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TechChartPageSharedModule)(); };
TechChartPageSharedModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: TechChartPageSharedModule });
TechChartPageSharedModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [AddButtonAutocompleteModule,
        BrowserModule,
        ChartsSharedModule,
        CommonModule,
        DateRangeModule,
        FullYearDateRangeModule,
        HelpModalModule,
        IconModule,
        LegacyAssetConversionCheckerModule,
        MetricSelectorModalModule,
        SecurityListSelectorModalModule,
        SingleSelectDropdownModule,
        SkeletonLoadersListModule,
        TechChartModule,
        TooltipModule,
        FoldersSharedModule,
        GetOwnerDisplayNamePipeModule,
        DisabledModule] });
